interface ErrorResponse {
    code: number;
    message: string;
}

export interface QuickbetsXState {
    quickbetsXData: any;
    quickbetsXDataLoading: boolean;
    quickbetsXDataError: ErrorResponse | null;
}


export enum QuickbetsXActionTypes {
    FETCH_QUICKBETS_X_DATA = "FETCH_QUICKBETS_X_DATA",
    FETCH_QUICKBETS_X_DATA_SUCCESS = "FETCH_QUICKBETS_X_DATA_SUCCESS",
    FETCH_QUICKBETS_X_DATA_ERROR = "FETCH_QUICKBETS_X_DATA_ERROR",
}

export type QuickbetsXAction =
    | { type: QuickbetsXActionTypes.FETCH_QUICKBETS_X_DATA }
    | { type: QuickbetsXActionTypes.FETCH_QUICKBETS_X_DATA_SUCCESS; payload: any[] }
    | { type: QuickbetsXActionTypes.FETCH_QUICKBETS_X_DATA_ERROR; payload: any };